// clone returns clone of input object.
// Return input type as is for primitive types including functions.
export function clone(obj) {
  // Handle the 3 simple types, and null or undefined
  if (null === obj || 'object' !== typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    const copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    const copy = [];
    for (let i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    const copy = {};
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = clone(obj[attr]);
      }
    }
    return copy;
  }

  // unhandled types throw error.
  throw new Error("Unable to copy obj! Its type isn't supported.");
}

// deepFreeze prevents the modification of existing property attributes and values, and prevents the addition of new properties.
export const deepFreeze = function deepFreeze(obj) {
  if ('object' !== typeof obj || obj === null) {
    return obj;
  }

  // Retrieve the property names defined on obj
  const propNames = Object.getOwnPropertyNames(obj);

  // Freeze properties before freezing self
  for (const name of propNames) {
    const prop = obj[name];

    // Freeze prop if it is an object
    if (typeof prop === 'object' && prop !== null) deepFreeze(prop);
  }

  // Freeze self (no-op if already frozen)
  return Object.freeze(obj);
};
export function deferred() {
  const deferred = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}

// async-await friendly way to "sleep" for a bit
export const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};
export function getDefaultStyleNonce() {
  var _document$getElementB;
  const nonce = (_document$getElementB = document.getElementById('sas-nc-style')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.nonce;
  return /^{{.*}}$/.test(nonce) ? undefined : nonce;
}
//# sourceMappingURL=util.js.map